import script from "./CourseSidebarProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSidebarProducts.vue?vue&type=script&setup=true&lang=js"

import "./CourseSidebarProducts.vue?vue&type=style&index=0&id=565db6e0&lang=scss"

const __exports__ = script;

export default __exports__